import { useCallback, useEffect } from 'react';

import { useLoadDataRequest } from '@futrli/shared-services';

import { AllowedPaymentTypes } from '../../../detail/reports/actions/actions';
import { fetchPaymentType } from '../../../../core/api/payment-type';
import { PAYMENT_TYPES } from '../../../../core/constants';

type RequestDataType = Awaited<ReturnType<typeof fetchPaymentType<AllowedPaymentTypes>>>

/**
 * Loads the payment data for the given prediction id/type
 * @param workspaceId - Workspace ID for the organisation
 * @param organisationId - Organisation ID
 * @param forecastId - Forecast ID
 * @param predictionId - Prediction ID
 * @param paymentTypeId - Payment type ID
 * @param paymentTypeType - Payment type type
 */
export const useLoadPaymentData = (
  workspaceId: string,
  organisationId: string,
  forecastId: string | undefined,
  predictionId: string | undefined,
  paymentTypeId: string | undefined,
  paymentTypeType: string | undefined,
) => {
  const hasAllParams = !!workspaceId && !!organisationId && !!forecastId && !!predictionId && !!paymentTypeId && !! paymentTypeType;
  const {load, ...rest} = useLoadDataRequest<RequestDataType>();

  const reload = useCallback(async () => {
    if (hasAllParams) {
      load(fetchPaymentType<AllowedPaymentTypes>(
        workspaceId,
        organisationId,
        forecastId,
        predictionId,
        paymentTypeType as PAYMENT_TYPES,
        paymentTypeId
      ));
    }
  }, [forecastId, hasAllParams, load, organisationId, paymentTypeId, paymentTypeType, predictionId, workspaceId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    hasAllParams,
    reload,
    ...rest
  };
};
